"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _UpArrow = _interopRequireDefault(require("../../icons/UpArrow"));

var _DownArrow = _interopRequireDefault(require("../../icons/DownArrow"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function PercentageArrow(_ref) {
  var value = _ref.value,
      size = _ref.size;
  if (typeof value === 'string') return null;
  return value > 0 ? _react.default.createElement(_UpArrow.default, {
    size: size,
    className: "mr-1"
  }) : value < 0 ? _react.default.createElement(_DownArrow.default, {
    size: size,
    className: "mr-1"
  }) : null;
}

PercentageArrow.propTypes = {
  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,
  size: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
};
PercentageArrow.defaultProps = {
  size: 15
};

var _default = _react.default.memo(PercentageArrow);

exports.default = _default;